<template>
    <kt-modal
        :visible="true"
        :title="recordTitle"
        size="modal-lg"
        @dismiss="onClose()"
    >
        <template #body>
            <part-form v-model="record" :pm-only="props.pmOnly"></part-form>
        </template>
    
        <template #footer>
            <div class="row w-100">
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="onClose()" class="btn btn-sm btn-outline-secondary form-control">Close</button>
                </div>
                <div class="col-4" v-if="record.Id">
                    <button @click="deleteRecord()" class="btn btn-sm btn-outline-danger form-control">Delete</button>
                </div>
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="saveRecord()" class="btn btn-sm btn-outline-primary form-control">Save</button>
                </div>
            </div>
        </template>
        
    </kt-modal>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import { PartModel } from "@/models/PartModel";
import ApiService from "@/services/ApiService";
import Helper from "@/services/Helper";
import Alert from "@/services/Alert";
import KtModal from "@/components/UI/KtModal.vue";
import PartForm from "@/components/Parts/PartForm.vue";

const props = defineProps({
    recordId: {
        type: String,
        required: true
    },
    requestId: {
        type: [Number, String],
        default: null
    },
    clientId: {
        type: [Number, String],
        default: null
    },
    techId: {
        type: [Number, String],
        default: null
    },
    pmOnly: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['close']);

const recordTitle = ref("Part Entry");

const newRecord = () => {
    const rec = new PartModel();
    // Pre-populate with requestId if provided
    if (props.requestId) {
        rec.RequestId = Number(props.requestId);
    }
    // Pre-populate with clientId if provided
    if (props.clientId) {
        rec.CustomerNumber = Number(props.clientId);
    }
    // Pre-populate with techId if provided
    if (props.techId) {
        rec.AssignedTo = Number(props.techId);
    }
    return rec;
};

const record = ref<PartModel>(newRecord());

const saveRecord = async () => {
    let data = Helper.prep(record.value);
    console.debug("save", data);
    data = await ApiService.savePart(data);
    // Close modal and refresh parent list
    emit('close');
};

const deleteRecord = async () => {
    Alert.notify("Deletion is currently disabled.");
};

const onClose = () => {
    emit('close');
};

const loadRecord = async (val: string) => {
    switch (val) {
        case "new":
            let tmp = newRecord();
            recordTitle.value = "New Part Entry";
            record.value = tmp;
            break;

        default:
            let rec = await ApiService.loadPart(val);
            recordTitle.value = "Edit Part Entry";
            record.value = rec;
            break;
    }
};

// Load record when component mounts or recordId changes
watch(() => props.recordId, (newId) => {
    if (newId) {
        loadRecord(newId);
    }
}, { immediate: true });
</script>
